import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@mantine/core';

import { useAddService } from '../api/addService';
import { Fields } from '../hooks/useServiceForm';

import { ServiceForm } from './ServiceForm';

type AddModalProps = {
  initialValues: Fields;
};

export const AddModal = NiceModal.create(({ initialValues }: AddModalProps) => {
  const modal = useModal();

  const { mutate, isLoading } = useAddService({
    department: initialValues.department,
    onSuccess: modal.hide,
  });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title="Новая услуга"
    >
      <ServiceForm
        isLoading={isLoading}
        onSubmit={(params) => mutate({ ...params })}
        initialValues={initialValues}
      />
    </Modal>
  );
});
